export default __webpack_public_path__ + "static/media/Resume-Adesina-Emmanuel.9b143520.pdf";